import { useBrowserModalControls } from '@telialt/common-hooks/src/useBrowserModalControls';

export const useDescriptionModalControls = () => {
    const modalControls = useBrowserModalControls<string>('descriptions-modal');

    return {
        isDescriptionModalOpen: modalControls.isModalOpen,
        openDescriptionModal: modalControls.openModal,
        closeDescriptionModal: modalControls.closeModal,
        id: modalControls.modalData,
    };
};
